import styled from 'styled-components'

export const BlogPostItem = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  &:hover {
    .BlogPostItem-Title {
      color: rgb(0, 103, 223);
    }
  }
  .BlogPostItem-Img-Container {
    width: 100%;
    margin-bottom: 32px;
    overflow: hidden;
    position: relative;
    padding-bottom: 56.2%;

    .BlogPostItem-Img {
      position: absolute;
      object-fit: cover;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .BlogPostItem__Item-Icon {
      position: absolute;
      right: 1px;
      bottom: 1px;
      height: 48px;
      width: 48px;
      z-index: 1;
    }
  }
  .BlogPostItem-Text-Category-Date {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .BlogPostItem-Text-Category {
      margin: 0 16px 0 0;
      color: ${p => p.theme.webMktPalette.text.secondary};
    }
    .BlogPostItem-Text-Date {
      color: rgba(0, 0, 0, 0.3);
    }
  }
  .BlogPostItem-Text-Category-Date,
  .BlogPostItem-Title {
    margin-bottom: 16px;
  }
  .BlogPostItem-Subtitle {
    color: ${p => p.theme.webMktPalette.text.secondary};
  }
  .BlogPostItem-Title {
    transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);
    ${p => p.theme.breakpoints.down('xs')} {
      letter-spacing: -1px;
    }
  }
`

export const BlogListingContainer = styled.div`
  ${(p: any) => {
    return p.totalPost > 9
      ? `
        .BlogListing__Ad {
          height: 100%;
          grid-row-start: 5;
          ${p.theme.breakpoints.down('sm')} {
            grid-row-start: 7;
          }
          ${p.theme.breakpoints.down('xs')} {
            grid-row-start: 10;
          }
        }
      `
      : ``
  }}
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-column-gap: 24px;
  align-items: flex-start;
  grid-row-gap: 64px;
  ${p => p.theme.breakpoints.down('sm')} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 14px;
  }
  ${p => p.theme.breakpoints.down('xs')} {
    grid-template-columns: minmax(100%, 1fr);
    grid-column-gap: 0;
  }
  .BlogListingContainer-Header {
    letter-spacing: -2px;
  }
`

export const SubscribeBanner = styled.div`
  width: 100%;
  height: 112px;
  background: #fa4616;
  padding: 0 100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-column-start: 1;
  grid-column-end: 4;
  grid-row-start: 2;
  grid-row-end: 3;
  ${p => p.theme.breakpoints.down('md')} {
    padding: 0 82px;
  }
  ${p => p.theme.breakpoints.down('sm')} {
    padding: 0 32px;
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 2;
    grid-row-end: 3;
  }
  ${p => p.theme.breakpoints.down('xs')} {
    grid-column-start: 1;
    grid-column-end: 2;
    padding: 24px;
    height: unset;
  }
  .SubscribeBanner__Inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    ${p => p.theme.breakpoints.down('xs')} {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .SubscribeBanner-Header {
    color: ${p => p.theme.webMktPalette.text.primaryWhite};
    letter-spacing: -1px;
    ${p => p.theme.breakpoints.down('sm')} {
      margin-right: 20px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      margin-right: 0;
      margin-bottom: 24px;
      max-width: 280px;
    }
  }
`
export const BlogListingOuter = styled.div`
  background: ${p => p.theme.webMktPalette.background.gray};
  position: relative;
  padding-bottom: 64px;
  padding-top: 10px;
  .BlogListingContainer-Header--SecondaryBlog {
    text-align: center;
  }
  ${({ $pageNumber, $theme }: any) => {
    if ($pageNumber !== 1) {
      return `padding-top: 64px;`
    }
  }}
`
export const SubscribeAd = styled.div`
  width: 100%;
  padding: 64px 24px;
  background: #ffffff;
  box-sizing: border-box;
  ${p => p.theme.breakpoints.down('md')} {
    padding: 48px 24px;
  }

  .SubscribeAd__Img-Container {
    margin: 0 0 32px 0;
    width: 64px;
    height: 64px;
    .SubscribeAd__Img {
      width: 100%;
      height: auto;
    }
  }
  .SubscribeAd-Header {
    max-width: 250px;
    letter-spacing: -1px;
  }
  .SubscribeAd-Header,
  .SubscribeAd-Body {
    margin: 0 0 16px 0;
    color: #000000;
    ${p => p.theme.breakpoints.down('md')} {
      margin: 0 0 24px 0;
    }
  }
`

export const CollectionRow = styled.div`
  position: relative;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-column-start: 1;
  grid-column-end: 4;
  grid-row-start: 4;
  grid-row-end: 5;
  ${p => p.theme.breakpoints.down('sm')} {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 4;
    grid-row-end: 5;
  }
  ${p => p.theme.breakpoints.down('xs')} {
    grid-column-start: 1;
    grid-column-end: 2;
    height: unset;
  }
  .CollectionRow__Background-Content {
    width: 100vw;
    height: 100%;
    position: absolute;
    background: white;
    z-index: 0;
  }
  .BlogListing__Collection-Row {
    z-index: 1;
  }
`

export const PaginationContainer = styled.div`
  padding: 64px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: auto;
  justify-content: center;
`
